// Chapter 11 writing frames ("מסגרות"), uploaded 1.11.2026 (Shlomo reviews them live on the site).
// One frame per step; all work on the single event the reader names in step 1.
// Mounted by App.tsx (FrameBox) at <div data-widget-anchor="ch11_fN"> in src/chapters/chapter-11.html.
// Answers persist in progress.fields under `${id}_${i}` (or `_c1`/`_c2` for two columns).
import type { Frame } from "./frames";

export const CH11_FRAMES: Frame[] = [
  {
    "id": "ch11_f1",
    "n": "11.1",
    "title": "הקשר שאני מעלה",
    "type": "scale2",
    "intro": "עובדות בלבד, בלי שיפוט. אין תשובה נכונה.",
    "fields": [
      "הקשר שבחרתי (מי):",
      "איפה קו האהבה בקשר הזה עכשיו",
      "הנקודה הגבוהה שהייתה, והנמוכה:",
      "מהשלושה (שליטה / כבוד והערכה / אמון), מה יושב מתחת לירידות שלי:"
    ]
  },
  {
    "id": "ch11_f2",
    "n": "11.2",
    "title": "בשליטתי, לא בשליטתי",
    "type": "twocol_named",
    "intro": "",
    "fields": [
      "בשליטתי בקשר הזה|לא בשליטתי",
      "על מה מהעמודה \"לא בשליטתי\" בזבזתי הכי הרבה אנרגיה השבוע:"
    ]
  },
  {
    "id": "ch11_f3",
    "n": "11.3",
    "title": "הריבוע שלי",
    "type": "lines",
    "intro": "",
    "fields": [
      "הפעם האחרונה שהיינו יחד, הריבוע שלי (סערה / אפטיות / תשוקה / שלווה):",
      "המיקוד שלי היה בפנים או בחוץ, ומה מעיד על זה:",
      "מה היה מעביר אותי ריבוע אחד שמאלה, לצד החיובי:"
    ]
  },
  {
    "id": "ch11_f4",
    "n": "11.4",
    "title": "כמה כוח אני נותנת",
    "type": "scale2",
    "intro": "1 = על אוטומט, 10 = כל כולי.",
    "fields": [
      "כמה מהכוח אני נותנת בקשר הזה היום",
      "איפה ה\"חצי כוח\" שלי מתבטא (דוגמה אחת מהשבוע):",
      "הפעם האחרונה שהזמן נעלם לי, ומה עשיתי:",
      "השעה בשבוע שבה אני נותנת בקשר הזה את כולי (מתי, מה):"
    ]
  },
  {
    "id": "ch11_f5",
    "n": "11.5",
    "title": "חמלה, ואיחול",
    "type": "lines",
    "intro": "",
    "fields": [
      "מה האדם הזה סוחב, שאני שוכחת כשאני כועסת:",
      "האיחול שלי לו או לה (במילים שלי):",
      "אותו איחול, לעצמי:"
    ]
  },
  {
    "id": "ch11_f6",
    "n": "11.6",
    "title": "הווקטור שלי",
    "type": "twocol_named",
    "intro": "",
    "fields": [
      "מחשבות שמקרבות|מחשבות שמרחיקות",
      "לאן הווקטור של השבוע מצביע, ומחשבה אחת שאני מוסיפה בכוונה:"
    ]
  },
  {
    "id": "ch11_f7",
    "n": "11.7",
    "title": "מה כבר עובד",
    "type": "lines",
    "intro": "",
    "fields": [
      "שלושה דברים שאני מודה עליהם, קטנים ומדויקים:",
      "",
      "",
      "חוזקה אחת שלו או שלה, שאולי לא אמרתי כבר שנה:",
      "מה כבר עובד בקשר הזה, שאפשר לבנות עליו:",
      "מעשה חסד אחד השבוע, בלי להכריז:"
    ]
  },
  {
    "id": "ch11_f8",
    "n": "11.8",
    "title": "מהיר ואיטי",
    "type": "twocol_named",
    "intro": "",
    "fields": [
      "המוח המהיר אמר|המוח האיטי אומר",
      "ההטיה שעבדה עליי (עיגון / זמינות / ייצוגיות / מסגור / אחרת):"
    ]
  },
  {
    "id": "ch11_f9",
    "n": "11.9",
    "title": "ההסכמה שלי",
    "type": "choice5",
    "intro": "סמני אחת, ואז שורה אחת:",
    "fields": [
      "דיבור ללא דופי · לא לקחת אישית · לא להניח הנחות · לעשות כמיטב היכולת",
      "הפעם האחרונה ששברתי אותה בקשר הזה, ומה היה קורה לו קיימתי אותה:"
    ]
  },
  {
    "id": "ch11_f10",
    "n": "11.10",
    "title": "הקשר שלי, טייק שני",
    "type": "final",
    "intro": "",
    "fields": [
      "בבקשה:",
      "סליחה:",
      "תודה:",
      "אהבה:",
      "הפעולה האחת שלי בקשר הזה השבוע (יום, שעה, מה):",
      "עם מי אני יכולה לדבר על הרגשות שלי:"
    ]
  }
];
